module.exports = __webpack_public_path__ + "img/time.e9bda929.png";